import { render } from "./ImagePreviewModal.vue?vue&type=template&id=6e0211ff&scoped=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js"

import "./ImagePreviewModal.vue?vue&type=style&index=0&id=6e0211ff&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0211ff"]])

export default __exports__